import React, { useCallback } from 'react';
import { ServicesContext } from '~/services';
import { convertPagination, defaultApiResponseHandler } from '~/util';

export interface MaclType {
    id: number;
    type: number;
    name: string;
    is_enabled: number;
    created_at: string;
    updated_at: string;
    patients_count: number;
    users_count: number;
}

export interface GetMaclsParamsType {
    is_expired?: boolean;
    page?: null | number;
    items_per_page?: null | number;
}
export const useGetMacls = () => {
    const services = React.useContext(ServicesContext);

    const getMacls = useCallback(
        async (params: GetMaclsParamsType, options?: ApiRequestOptionsType) => {
            try {
                const result = await services.api.call(
                    {
                        method: 'get',
                        url: '/api/macls',
                        params,
                        data: {},
                        headers: {
                            'Content-Type': 'application/ld+json',
                        },
                    },
                    options
                );
                return {
                    results: result.data['hydra:member'] as MaclType[],
                    pagination: convertPagination(result.data),
                };
            } catch (error) {
                throw defaultApiResponseHandler(error);
            }
        },
        [services.api]
    );

    return getMacls;
};
